import * as actionTypes from "./actionTypes";

const initialState = {
    values: {},
    table: {
        data: [],
        sort: {
            property: undefined,
            direction: undefined
        },
        totalElements: undefined,
        pageNumber: undefined,
        totalPages: undefined
    },
    entityList: [],
    //form specific:
    entityData: {},

    loading: false,
    loadingListRequest: false,
    loadingCreateRequest: false,
    loadingEditRequest: false,
    loadingDeleteRequest: false,

    entityWasCreated: false,
    entityWasEdited: false,
    entityWasDeleted: false,

    error: undefined
};

const entitiesReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.GET_ENTITY_LIST_REQUEST:
            return {
                ...state,
                loadingListRequest: true
            };
        case actionTypes.GET_ENTITY_LIST_SUCCESS:
            return {
                ...state,
                loadingListRequest: false,
                entityList: payload
            };
        case actionTypes.GET_ENTITY_LIST_FAILED:
            return {
                ...state,
                loadingListRequest: false,
            };
        case actionTypes.ENTITY_SEARCH_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.ENTITY_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                table: {
                    ...state.table,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    totalElements: payload.totalElements,
                    sort: {
                        direction: payload.sort[0].direction,
                        property: payload.sort[0].property,
                    },
                    pageSize: payload.pageable.pageSize,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.GET_ENTITY_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.GET_ENTITY_SUCCESS:
            return {
                ...state,
                loading: false,
                entityData: payload
            };
        case actionTypes.GET_ENTITY_FAILED:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.CREATE_ENTITY_REQUEST:
            return {
                ...state,
                loadingCreateRequest: true
            };
        case actionTypes.CREATE_ENTITY_SUCCESS:
            return {
                ...state,
                loadingCreateRequest: false,
                entityWasCreated: true
            };
        case actionTypes.CREATE_ENTITY_FAILED:
            return {
                ...state,
                loadingCreateRequest: false,
                entityWasCreated: false
            };
        case actionTypes.EDIT_ENTITY_REQUEST:
            return {
                ...state,
                loadingEditRequest: true
            };
        case actionTypes.EDIT_ENTITY_SUCCESS:
            return {
                ...state,
                loadingEditRequest: false,
                entityWasEdited: true
            };
        case actionTypes.EDIT_ENTITY_FAILED:
            return {
                ...state,
                loadingEditRequest: false,
                entityWasEdited: false
            };
        case actionTypes.DELETE_ENTITY_REQUEST:
            return {
                ...state,
                loadingDeleteRequest: true
            };
        case actionTypes.DELETE_ENTITY_SUCCESS:
            return {
                ...state,
                loadingDeleteRequest: false,
                entityWasDeleted: true
            };
        case actionTypes.DELETE_ENTITY_FAILED:
            return {
                ...state,
                loadingDeleteRequest: false,
                entityWasDeleted: false
            };
        case actionTypes.RESET_ENTITIES_FORM:
            return {
                ...state,
                entityData: {},
                loading: false,
                loadingListRequest: false,
                loadingCreateRequest: false,
                loadingEditRequest: false,
                loadingDeleteRequest: false,
                entityWasCreated: false,
                entityWasEdited: false,
                entityWasDeleted: false,
                error: undefined
            }
        default:
            return state;
    }
};

export default entitiesReducer;